export default __webpack_public_path__ + "static/media/ProfileAudi.6427698e.svg";